import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import IconButton from '@mui/material/IconButton'
import CircularProgress from '@mui/material/CircularProgress'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import Edit from '@mui/icons-material/Edit'
import Delete from '@mui/icons-material/Delete'
import { FormattedMessage } from 'react-intl'
import { isEmpty, get } from 'lodash'

const PageSectionTable = ({
  items,
  emptyId,
  keyField = 'key',
  valueField = 'value',
  maskValues = false,
  loading,
  onItemEdit,
  onItemDelete,
}) => {
  const [revealedIds, setRevealedIds] = useState(new Set())

  const toggleReveal = (id) => {
    setRevealedIds((prev) => {
      const next = new Set(prev)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })
  }

  if (loading) {
    return <CircularProgress size={24} />
  }

  if (isEmpty(items)) {
    return (
      <Typography variant="body2" color="text.secondary">
        <FormattedMessage id={emptyId} />
      </Typography>
    )
  }

  const hasActions = maskValues || onItemEdit || onItemDelete

  return (
    <Box sx={{ overflowX: 'auto' }}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: hasActions ? '40%' : '50%' }}>
            <FormattedMessage id="common.table.key" />
          </TableCell>
          <TableCell sx={{ width: hasActions ? '40%' : '50%' }}>
            <FormattedMessage id="common.table.value" />
          </TableCell>
          {hasActions && <TableCell sx={{ width: '20%' }} />}
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((item) => {
          const key = get(item, keyField)
          const value = get(item, valueField)
          const isRevealed = revealedIds.has(item.id)

          return (
            <TableRow key={item.id}>
              <TableCell>{key}</TableCell>
              <TableCell>
                {maskValues ? (isRevealed ? value : '••••••••') : value}
              </TableCell>
              {hasActions && (
                <TableCell>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
                    {maskValues && (
                      <IconButton
                        size="small"
                        onClick={() => toggleReveal(item.id)}
                      >
                        {isRevealed ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </IconButton>
                    )}
                    {onItemEdit && (
                      <IconButton
                        size="small"
                        onClick={() => onItemEdit(item)}
                      >
                        <Edit fontSize="small" />
                      </IconButton>
                    )}
                    {onItemDelete && (
                      <IconButton
                        size="small"
                        onClick={() => onItemDelete(item)}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    )}
                  </Box>
                </TableCell>
              )}
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
    </Box>
  )
}

export default PageSectionTable
